//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import transition from "~/assets/js/transition";

export default {
  transition,

  data() {
    return {
      faq: [
        {
          question: "Quel rôle joue le référencement pour mon site internet ?",
          answer: `Le référencement joue un rôle crucial dans la visibilité en ligne de votre site web. En effet un bon référencement améliore le classement de <a class="link-mesh to-html" aria-link="web" href="/prestations/site-internet/">votre site</a> sur les moteurs de recherche, plus il est optimisé plus votre positionnement sera élevé, ce qui augmentera votre trafic organique, c’est-à-dire le trafic provenant de recherches non-payantes. Un bon référencement implique un bon ciblage des mots-clés pertinents avec votre activité, votre secteur géographique et vos concurrents afin d’attirer les utilisateurs qui recherchent spécifiquement des informations liées à votre domaine. L’expérience utilisateur (UX) peut également améliorer votre référencement, avec un site rapide, facile à charger et agréable à naviguer. En obtenant un bon classement dans les résultats de recherches, un site internet bien référencé peut réduire de façon significative sa dépendance à la publicité payante. De plus, un bon référencement est un bon indicateur de l’efficacité de votre site, il permet d’identifier les domaines à améliorer et d’ajuster le tir.`,
          active: false,
        },
        {
          question: "Quel est l’intérêt commercial d’un SEO efficace ?",
          answer:
            "Le référencement, également appelé SEO (Search Engine Optimization) lorsqu’il est optimisé améliore la visibilité en ligne et attire du trafic qualifié. Les sites classés dans les premiers résultats de recherches sont perçus par les utilisateurs comme plus crédibles dignes de confiance. Le référencement contribue à établir une présence en ligne solide et professionnelle, facilite l’acquisition de nouveaux leads et la fidélisation de votre clientèle.",
          active: false,
        },
        {
          question: "Quelle est la différence entre le SEO et le SEA ?",
          answer: `Le SEO et le SEA sont deux approches distinctes de la stratégie de référencement qu’une entreprise peut adopter pour améliorer sa visibilité sur internet. Leur mise en œuvre est cependant différente, le SEO est une approche organique pour améliorer le classement d’un site sur les moteurs de recherche et repose sur une des technique d’optimisation et de création de contenus comprenant des mots-clés cibles. Le SEA consiste quant à lui à acheter des annonces publicitaires pour apparaître dans le haut du classement des résultats de recherches. Le SEA implique alors des coûts liés au clic sur l’annonce et donne des résultats immédiats, l’efficacité est cependant limitée par le budget alloué à la campagne et il peut être perçu moins authentique par les utilisateurs. <a class="link-mesh to-html" aria-link="/agence-de-communication/" href="agency">NANCOMCY</a> vous accompagne dans votre stratégie de référencement, qu’il s’agisse de SEO ou de campagnes Meta Ads.`,
          active: false,
        },
        {
          question: "Quels sont les différents types de référencement ?",
          answer: `Pour optimiser votre visibilité en ligne, il existe plusieurs types de référencement, chacun répondant à des objectifs spécifiques influent d'une manière spécifique sur les performances de votre site. D’une manière générale, une approche globale combinant plusieurs méthodes peut être la plus efficace pour booster votre référencement.<br />
Le SEO va améliorer le classement du site dans les résultats de recherche organiques grâce à une optimisation du contenu, un balisage HTML, la création de liens, une meilleure expérience utilisateur, etc. <br />
Le SEA va permettre d’obtenir une visibilité immédiate en plaçant des annonces payantes dans les résultats de recherche avec des campagnes publicitaires, des enchères de mots-clés ou des annonces payantes. <br />
Le SEO local améliore la visibilité d'un site dans les résultats de recherche locaux avec une optimisation des fiches Google My Business, l’utilisation de mots-clés locaux, l’obtention d'avis locaux, etc. <br />
Le SEO technique optimise la structure technique du site pour améliorer son indexation et sa lisibilité par les moteurs de recherche grâce à des balises méta, des balises d'en-tête, et de la structure des URL. <br />
Le SEO on-page optimise les éléments directement sur les pages du site pour améliorer leur classement par l’utilisation de mots-clés, la création de contenu de qualité, l’optimisation des balises. <br />
Le SEO off-page améliore la réputation et l'autorité du site en dehors de ses pages par la création de liens de qualité, la participation aux médias sociaux, les relations publiques en ligne, etc. <br />
Le SEO mobile optimise le site pour une expérience utilisateur optimale sur les appareils mobiles grâce à la conception réactive, l’optimisation de la vitesse de chargement, et l’utilisation de balises adaptées au mobile. <br />
Le SEO vidéo augmente la visibilité des contenus vidéo dans les résultats de recherche grâce à l'optimisation des titres et descriptions vidéo, et à l’utilisation de balises vidéo. <br />
Le SEO image optimise la visibilité des images dans les résultats de recherche grâce à l’utilisation de balises descriptives, l’optimisation de la taille des images, et à l’utilisation de noms de fichiers pertinents. <br />
Le SEO international optimise un site pour apparaître dans les résultats de recherche internationaux avec l’utilisation de balises hreflang, et à la création de contenu multilingue, optimisation pour les moteurs de recherche spécifiques à chaque pays. <br />`,
          active: false,
        },
      ],

      steps: [
        {
          title: "Audit SEO et analyse de vos performances",
          content:
            "Évaluation détaillée de la performance de votre référencement actuel, analyse technique et sémantique de votre contenu.",
          bgColor: "#F5FDFC",
        },
        {
          title: "Analyse de votre concurrence SEO",
          content:
            "Analyse des stratégies de référencement utilisées par les concurrents dans votre secteur et identification des optimisations à mettre en place pour gagner en compétitivité.",
          bgColor: "#F0FCFB",
        },
        {
          title: "Choix du / des positionnement(s) SEO",
          content:
            "Définition des objectifs de positionnement et recherche sémantique et de mots-clés pertinents avec une stratégie de courte et de longue traîne.",
          bgColor: "#F0FCFB",
        },
        {
          title: "Définition de l’arborescence",
          content:
            "Mise en place d'une structure hiérarchique de l'information et définition de clusters sémantiques SEO et d'un maillage des liens internes du site.",
          bgColor: "#E6FAF9",
        },
        {
          title: "Rédaction des contenus optimisés SEO",
          content:
            "Création de contenus optimisés  et structurés intégrant les mots-clés et le champ sémantique définis.",
          bgColor: "#E1F9F7",
        },
        {
          title: "Optimisations techniques et SEO On site",
          content:
            "Amélioration de la visibilité et de l'indexation du site sur les moteurs de recherche, ajustements techniques, de sécurité et de navigation.",
          bgColor: "#D7F7F5",
        },
        {
          title: "Campagnes de netlinking et SEO Off site",
          content:
            "Renforcement de la crédibilité et de la visibilité du site en dehors de ses propres pages et mise en place d'une stratégie de construction de liens entrants.",
          bgColor: "#CDF5F2",
        },
        {
          title: "Évolution du référencement naturel",
          content:
            "Veille et évaluation des performances, identification des opportunités d'optimisation et ajustement de la stratégie SEO.",
          bgColor: "#CDF5F2",
        },
      ],
    };
  },

  head() {
    return {
      title: "Référencement Naturel : Agence SEO à Nancy - NANCOMCY",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Donnez de l’élan à votre visibilité en ligne avec des stratégies de référencement pensées par nos équipes. Chez NANCOMCY, nous mettons nos expertises SEO et SEM à votre disposition pour améliorer votre positionnement et capter un trafic qualifié. Confiez-nous votre référencement pour des résultats durables !",
        },
      ],
    };
  },

  mounted() {
    document.body.style.overflow = "hidden";
  },
};
